var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7101 15.9298C15.5801 15.9298 15.4501 15.8998 15.3301 15.8198L12.2301 13.9698C11.4601 13.5098 10.8901 12.4998 10.8901 11.6098V7.50977C10.8901 7.09977 11.2301 6.75977 11.6401 6.75977C12.0501 6.75977 12.3901 7.09977 12.3901 7.50977V11.6098C12.3901 11.9698 12.6901 12.4998 13.0001 12.6798L16.1001 14.5298C16.4601 14.7398 16.5701 15.1998 16.3601 15.5598C16.2101 15.7998 15.9601 15.9298 15.7101 15.9298Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeclock);
export default __webpack_public_path__ + "static/media/timeclock.6d8ddc75ac218f4e8425c4998999beca.svg";
export { ForwardRef as ReactComponent };